import {
    Coins, TrendingUp, Gift, CreditCard, History, ArrowDownCircle,
    ArrowUpCircle, Target, Wallet, HandHelping, Phone, Wifi, Zap, Send,
    User, HelpCircle, BarChart2, PiggyBank, Repeat, Bookmark, LineChart,
} from "lucide-react";

export interface MenuItem {
    name: string;
    icon: any;
    link: string;
}

export interface MenuSection {
    title: string;
    items: MenuItem[];
}

export const ngWalletMenuItems: MenuSection[] = [

    {
        title: "Send and pay",
        items: [
            { name: "Fund wallet", icon: Wallet,      link: "/fund"     },
            { name: "Withdraw",    icon: HandHelping, link: "/withdraw" },
            { name: "Airtime",     icon: Phone,       link: "/airtime"  },
            { name: "Data",        icon: Wifi,        link: "/datapage" },
            { name: "Bills",       icon: Zap,         link: "/bills"    },
            { name: "Donate",      icon: Send,        link: "/donate"   },
        ],
    },
    {
        title: "Manage finances",
        items: [
            { name: "Add bank accounts",   icon: CreditCard,      link: "/link-bank"         },
            { name: "Transaction history", icon: History,         link: "/history"           },
            { name: "Income analysis",     icon: ArrowDownCircle, link: "/income-analysis"   },
            { name: "Spending analysis",   icon: ArrowUpCircle,   link: "/spending-analysis" },
            { name: "Set goals",           icon: Target,          link: "/goals"             },
        ],
    },

    {
        title: "Invest",
        items: [
            { name: "Invest",      icon: LineChart, link: "/invest"           },
            { name: "Savings",     icon: PiggyBank, link: "/savings"          },
            { name: "Auto-Invest", icon: Repeat,    link: "/invest/plans"     },
            { name: "Watchlist",   icon: Bookmark,  link: "/invest/watchlist" },
            { name: "Analytics",   icon: BarChart2, link: "/invest/analytics" },
        ],
    },
    {
        title: "Profile and support",
        items: [
            { name: "Your profile", icon: User,       link: "/profile" },
            { name: "Help centre",  icon: HelpCircle, link: "/help"    },
        ],
    },
    {
        title: "Learn and earn",
        items: [
            { name: "Rewards",        icon: Coins,     link: "/rewards" },
            { name: "Refer and earn", icon: TrendingUp, link: "/refer"  },
            { name: "Learn",          icon: Gift,      link: "/learn"   },
        ],
    },
];